import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const prefix = 'tuitionContinuityV2.modals.financialBlockage';

interface FinancialBlockageModalProps {
  isOpen: boolean;
  toggle: () => void;
}

export default function FinancialBlockageModal({
  isOpen,
  toggle,
}: FinancialBlockageModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <div className="text-center p-3">
        <Icon name="warning" size="65px" color="warning" />
        <h1 className="text-dark fs-22 mt-3">{t(`${prefix}.title`)}</h1>
        <p className="fs-16 mt-2">{t(`${prefix}.body`)}</p>
        <Row className="mt-4">
          <Col>
            <Button text={t(`${prefix}.buttonOk`)} fullwidth onClick={toggle} />
          </Col>
        </Row>
      </div>
    </Modal>
  );
}
